import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useMutation } from '@apollo/client';
import { MeData } from 'graphQL/Auth/types';
import { useUserInformation } from 'graphQL/Zustand/useUserInformation';
import { UPDATE_HOST_PROFILE } from '..';
import { HostBaseParam } from '../types';
import { useGetMe } from 'graphQL/Auth/user/useGetMe';

export function useMutationUpdateHostProfile() {
  const myInfo: MeData = useUserInformation((state: any) => state.userInfo);
  const { handleRefetchUser } = useGetMe();

  const [updateHostProfie] = useMutation(UPDATE_HOST_PROFILE);

  const [hostBaseParams, setHostBaseParams] = useState<HostBaseParam>({
    hostId: myInfo.me.host.id,
    param: {
      name: myInfo.me.host.name,
      description: myInfo.me.host.description,
      phoneNumber: myInfo.me.host.phoneNumber || '',
      // 알림 수신 연락처는 어드민에서만 설정 — 빼고 보내면 서버가 비워 저장하므로 조회한 값을 그대로 보낸다
      notificationPhoneNumber:
        myInfo.me.host.personalInfo.notificationPhoneNumber,
      email: myInfo.me.host.personalInfo.email,
    },
  });

  const handleUpdateHostBaseParams = (key: string, value: any) => {
    setHostBaseParams({ ...hostBaseParams, [key]: value });
  };

  const handleUpdateHostProfile = async (callback: () => void) => {
    try {
      const response = await updateHostProfie({
        variables: hostBaseParams,
      });

      if (response) {
        window.showToast('프로필이 저장되었습니다.', 'success', 3000);

        callback();
        handleRefetchUser();
        // window.location.reload();
      }
    } catch (error) {
      console.log(error);
    }
  };

  return {
    hostBaseParams,
    handleUpdateHostBaseParams,
    handleUpdateHostProfile,
  };
}
